import { z } from "zod";
import { SystemEntity } from "@erp/shared-types";
import { defineStepConfig } from "../../registry/helpers";
import { entityOfType } from "../../utils/system-entities";

export const upsertSpaSourceStep = defineStepConfig({
  type: "upsert_spa_source",
  name: "Upsert SPA Source",
  description:
    "Upsert a SpaSource record linking a raw vendor file to an optional SpaRequest. " +
    "Idempotent on (organizationId, fileId) — updates vendor and metadata when a record already exists.",
  category: "Integration",
  libraryModule: "Pricing",

  inputSchema: z.object({
    file: entityOfType(SystemEntity.CORE_FILE).describe(
      "The raw vendor SPA file to register as a source.",
    ),
    vendor: z
      .string()
      .min(1)
      .describe("Vendor key, e.g. 'hubbell', 'rockwell', 'abb'."),
    spaRequestId: z
      .string()
      .uuid()
      .optional()
      .describe("FK to the originating SpaRequest, when known."),
    metadata: z
      .record(z.string(), z.unknown())
      .optional()
      .describe(
        "Arbitrary vendor-specific metadata to store alongside the source file.",
      ),
  }),

  outputSchema: z.object({
    spaSourceId: z.string().uuid().describe("The persisted SpaSource id."),
    created: z
      .boolean()
      .describe(
        "True when a new row was created; false when an existing row was updated.",
      ),
  }),

  configSchema: z.object({}),

  emits: [] as const,
});
